import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { ILowRateMortgagePromo } from '../../../types/promosPage';
import { MortgagePromoCard } from '../../MortgagePromoCard';
import { RoundArrowLeft } from '../../RoundArrowLeft';
import { RoundArrowRight } from '../../RoundArrowRight';
import { Section } from '../../Section';
import { VerticalSlider } from '../VerticalSlider';

interface ILowRateMortgagePromosProps {
  onPromoClick(promo: ILowRateMortgagePromo, position: number): void;
  onPromoShow(promo: ILowRateMortgagePromo, position: number): void;
  promoList: ILowRateMortgagePromo[];
  title: string;
}

export const LowRateMortgagePromos: React.FC<ILowRateMortgagePromosProps> = ({
  onPromoClick,
  onPromoShow,
  promoList,
  title,
}) => {
  return (
    <Section title={title} data-testid="LowRateMortgagePromos">
      <VerticalSlider itemGap="16px" rightArrow={RoundArrowRight} leftArrow={RoundArrowLeft}>
        {promoList.map((promo, idx) => {
          const position = idx + 1;

          return (
            <ActionAfterViewObserver
              key={promo.uniqueId}
              callback={() => onPromoShow(promo, position)}
              triggerOnce
              wrapper={false}
            >
              <MortgagePromoCard promo={promo} onClick={() => onPromoClick(promo, position)} />
            </ActionAfterViewObserver>
          );
        })}
      </VerticalSlider>
    </Section>
  );
};
